import { render } from "./createVideo.vue?vue&type=template&id=95ae5590"
import script from "./createVideo.vue?vue&type=script&lang=js"
export * from "./createVideo.vue?vue&type=script&lang=js"

import "./createVideo.vue?vue&type=style&index=0&id=95ae5590&lang=scss"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__